
import { InvoiceAccountMergeData } from '../../data/invoice.account.merge.data';
import { FakeAccountMergeData } from './fake.account.merge.data';

export class FakeInvoiceAccountMergeData extends InvoiceAccountMergeData {

    constructor() {

        super();

        const account = new FakeAccountMergeData();

        this.email = account.email;
        this.phone = account.phone;
        this.friendlyName = account.name;
        this.name = account.name;
        this.type = 'Customer';
        this.contactName = 'Robert Charles';
        this.contactId = account._id;
        this.taxId = '123456789';

    }

}